import React, { useState, useEffect } from "react";
import { Button, Typography } from "@material-tailwind/react";
const LoginForm: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  // Mock credentials
  const mockCredentials = {
    username: "admin",
    password: "admin123",
  };

  // Check if there's a previous failed login attempt
  useEffect(() => {
    const failedLogin = sessionStorage.getItem("failedLogin");
    if (failedLogin) {
      setError("Session expired. Please log in again.");
      sessionStorage.removeItem("failedLogin");
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    // Check if credentials match mock data
    if (
      username === mockCredentials.username &&
      password === mockCredentials.password
    ) {
      // Store authentication state in localStorage
      const expiration = Date.now() + 60 * 1000; // 1 minute from now
      localStorage.setItem(
        "isAuthenticated",
        JSON.stringify({
          isAuthenticated: true,
          username: username,
          expiration: expiration,
        })
      );

      // Reload the page to trigger authentication check
      window.location.reload();
    } else {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full">
        <div className="w-full max-w-2xl mx-auto p-10 bg-white rounded-xl shadow-lg ring-1 ring-black ring-opacity-5">
          <div className="mb-8">
            <Typography
              variant="h2"
              className="text-2xl font-bold font-inter text-gray-900"
              placeholder={undefined}
              onResize={undefined}
              onResizeCapture={undefined}
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            >
              Log in the system
            </Typography>
            <p className="text-base font-normal font-inter text-gray-500">
              Needs Secondary Information
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-8">
            {error && (
              <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded">
                {error}
              </div>
            )}

            <div>
              <label
                htmlFor="username"
                className="block text-sm font-normal font-roboto text-gray-500 mb-2"
              >
                Username
              </label>
              <div className="relative rounded-md shadow-sm">
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="example@username"
                  className="box-border flex flex-row items-center py-[15px] px-4 gap-2 border border-gray-300 rounded-lg w-full focus:border-[#6172F3] focus:ring-1 focus:ring-[#6172F3] focus:outline-none"
                  required
                />
              </div>
            </div>

            <div className="mt-6">
              <label
                htmlFor="password"
                className="block text-sm font-normal font-roboto text-gray-500 mb-2"
              >
                Password
              </label>
              <div className="relative rounded-md shadow-sm">
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••••"
                  className="box-border flex flex-row items-center py-[15px] px-4 gap-2 border border-gray-300 rounded-lg w-full focus:border-[#6172F3] focus:ring-1 focus:ring-[#6172F3] focus:outline-none"
                  required
                />
              </div>
            </div>

            {/* System down message */}
            <Typography
              className="font-roboto font-normal text-sm text-gray-400"
              placeholder={undefined}
              onResize={undefined}
              onResizeCapture={undefined}
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
            >
              We're experiencing issues logging in because the main system is
              down and you can't authenticate with your Microsoft account or the
              default auto-login, please follow the alternative steps provided.
            </Typography>

            <div className="pt-6">
              <Button
                type="submit"
                className="flex flex-row justify-center items-center py-[11px] px-8 gap-2 bg-[#6172F3] shadow-md rounded-lg w-full font-roboto font-bold text-xs text-white"
                placeholder={undefined}
                onResize={() => {}}
                onResizeCapture={() => {}}
                onPointerEnterCapture={() => {}}
                onPointerLeaveCapture={() => {}}
              >
                Log In
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
